"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nameof = void 0;
function nameof(name) {
    return name;
}
exports.nameof = nameof;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibmFtZS1vZi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9oZWxwZXJzL25hbWUtb2YudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsU0FBZ0IsTUFBTSxDQUFnQixJQUF5QjtJQUMzRCxPQUFPLElBQUksQ0FBQztBQUNoQixDQUFDO0FBRkQsd0JBRUMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZnVuY3Rpb24gbmFtZW9mPFQsIFUgPSBzdHJpbmc+KG5hbWU6IEV4dHJhY3Q8a2V5b2YgVCwgVT4pOiBVIHtcbiAgICByZXR1cm4gbmFtZTtcbn1cbiJdfQ==